<template>
  <div
    v-if="hasData"
    class="insights-meetings-widget-recurring"
  >
    <AppChartLegend
      :values="legend"
      :include-values="false"
    />

    <AppChartStacked
      :chart-id="widgetKey"
      :sections="typeSections"
      :chart-data="typeData"
      :color-range="recurringColors"
      :column-spacing="0.16"
      :label-ellipsis="2"
      :padding-outer="0.35"
      :y-tick-format="tickFormat"
      has-y-axis
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AppChartStacked from '~/components/AppChartStacked.vue';
import AppChartLegend from '~/components/AppChartLegend.vue';
import { InsightsTracking } from '~/mixins';

import { INSIGHTS } from '~/app_constants';

export default {
  name: 'InsightsMeetingsRecurring',
  components: {
    AppChartStacked,
    AppChartLegend,
  },
  mixins: [InsightsTracking],
  props: {
    period: {
      type: String,
      default: 'week',
      validator: (value) => ['week', 'day'].includes(value),
    },
  },
  data: () => ({
    widgetKey: INSIGHTS.api.meetings,
    legend: Object.freeze([
      { key: 'recurring', label: 'Recurring' },
      { key: 'non-recurring', label: 'Non-recurring' },
    ]),
    recurringColors: Object.freeze(['#0168DD', '#A7D9FC']),
  }),
  computed: {
    ...mapGetters(['meetings']),
    hasData() {
      const dataType = this.period === 'week' ? 'weekdays' : 'time_of_day';

      return this.meetings && this.meetings[dataType]?.length;
    },
    typeData() {
      if (!this.hasData) {
        return null;
      }

      return this.period === 'week' ? this.meetings.weekdays : this.timeOfDay;
    },
    typeSections() {
      return ['recurring', 'non_recurring'];
    },
    tickFormat() {
      return this.period === 'week' ? '' : '%';
    },
    timeOfDay() {
      if (!this.meetings.time_format.includes('12')) {
        return this.meetings.time_of_day;
      }

      return this.meetings.time_of_day.map((time) => {
        const [first, second] = time.label.split('-');
        const firstHour = this.format24hto12h(first);
        const secondHour = this.format24hto12h(second);
        const label = `${firstHour.hour}-${secondHour.hour} ${secondHour.meridien}`;

        return { ...time, label };
      });
    },
  },
  methods: {
    format24hto12h(time) {
      const hour = +time % 24;

      return {
        hour: hour % 12 || 12,
        meridien: hour >= 12 ? 'pm' : 'am',
      };
    },
  },
};
</script>
